import React from "react"

interface SubTitleTableProps {
	content: React.ReactNode
}

const SubTitleTable: React.FC<SubTitleTableProps> = ({
	content,
}): JSX.Element => {
	return <>{content}</>
}

export default SubTitleTable
